<div>
   <app-list-device-support [mobile]="true"></app-list-device-support>
</div>